<template>
  <div class="elements--desktop">
    <FormContainer>
      <template #title>Coûts de formation</template>
      <template #message>
        <BasicAlert
          v-if="msgInformation"
          alertType="info"
          :alertLabel="msgInformation"
        />
        <BasicAlert
          v-if="msgErreur"
          :alertLabel="msgErreur!"
        />
      </template>
      <template #content>
        <div>
          <div class="cardLayoutWrapper cardLayoutWrapper--no-pointer cardLayoutWrapper--header">
            <BasicCell
              v-for="(col, i) in headerCols"
              :key="i"
              :span="col.span"
              :text="col.text"
              :extra-class="col.extraClass"
            />
          </div>
          <div class="listCardDesktopWrapper">
            <template
              v-for="(ligneFrais, i) in lignesFrais"
              :key="i"
            >
              <div
                v-if="ligneFrais.type === 'frais' && ligneFrais.meta?.montant?.$status !== PropertyStatus.NotPresent"
                class="cardLayoutWrapper cardLayoutWrapper--no-pointer"
              >
                <BasicCell :span="afficheQuantité ? 10 : 12">
                  <BasicText
                    v-if="ligneFrais.isFirstOfMode"
                    wrap
                  >
                    {{ ligneFrais.fraisTitre }}
                  </BasicText>
                </BasicCell>
                <BasicCell :span="1" />
                <BasicCell :span="afficheQuantité ? 10 : 13">
                  <WrapperLabelHint
                    :label="getNatureFraisLib(ligneFrais.frais.nature)"
                    :required="ligneFrais.meta?.montant?.$status === PropertyStatus.Required"
                    :hint="ligneFrais.hint"
                  />
                </BasicCell>
                <BasicCell :span="1" />
                <BasicCell :span="afficheQuantité ? 6 : 7">
                  <WrapperInputNumber
                    :model-value="ligneFrais.frais.montant"
                    input-type="table"
                    textAlign="right"
                    @update:model-value="
                      (montant) =>
                        modifieFrais({
                          mode: ligneFrais.frais.mode!,
                          nature: ligneFrais.frais.nature!,
                          valeur: montant as any,
                          field: 'montant',
                        })
                    "
                    :placeholder="afficheQuantité ? (LibelleTypeMontantFrais[ligneFrais.frais.nature as NatureFrais] ?? '€') : '€'"
                    :decimal="2"
                    separateur
                    deletable
                    :readonly
                    :alertLabel="ligneFrais.meta?.montant?.$messageErreurDirty!"
                    :required="ligneFrais.meta?.montant?.$status === PropertyStatus.Required"
                    :disabled="(ligneFrais.meta?.montant?.$status as PropertyStatus) === PropertyStatus.NotPresent"
                  />
                </BasicCell>
                <template v-if="afficheQuantité">
                  <BasicCell :span="1" />
                  <BasicCell :span="6">
                    <WrapperInputNumber
                      :model-value="ligneFrais.frais.quantite"
                      input-type="table"
                      @update:model-value="
                        (quantite) =>
                          modifieFrais({
                            mode: ligneFrais.frais.mode!,
                            nature: ligneFrais.frais.nature!,
                            valeur: quantite as any,
                            field: 'quantite',
                          })
                      "
                      :decimal="0"
                      separateur
                      deletable
                      :placeholder="LibelleTypeQuantiteFrais[ligneFrais.frais.nature as NatureFrais]"
                      :readonly
                      :alertLabel="ligneFrais.meta?.quantite?.$messageErreurDirty!"
                      :required="ligneFrais.meta?.quantite?.$status === PropertyStatus.Required"
                      :disabled="ligneFrais.meta?.quantite?.$status === PropertyStatus.NotPresent"
                      text-align="right"
                    />
                  </BasicCell>
                </template>
              </div>
              <div
                v-else-if="ligneFrais.type === 'total'"
                class="cardLayoutWrapper cardLayoutWrapper--no-pointer total--row"
              >
                <BasicCell :span="36">
                  <BasicText weight="bold">
                    {{ ligneFrais.totalLabel }}
                  </BasicText>
                </BasicCell>
              </div>
            </template>
          </div>
        </div>
      </template>
    </FormContainer>
  </div>
  <div class="elements--mobile">
    <FormContainer
      v-for="(typeData, type) in fraisDataParMode"
      :key="type"
    >
      <template #title>{{ typeData.fraisTitre }}</template>
      <template #content>
        <div class="form__bloc">
          <div
            v-for="(frais, index) in typeData.frais"
            :key="index"
            class="col-18 col-md-36 form__bloc"
            style="margin: 0"
          >
            <BasicText
              weight="bold"
              size="body-m"
              class="col-36"
              wrap
            >
              {{ getNatureFraisLib(frais.nature) }}
            </BasicText>
            <WrapperInputNumber
              v-if="frais.baseCalcul === 'Quantite'"
              :model-value="frais.quantite"
              @update:model-value="
                (quantite) =>
                  modifieFrais({
                    mode: frais.mode!,
                    nature: frais.nature!,
                    valeur: quantite!,
                    field: 'quantite',
                  })
              "
              :label="LibelleTypeQuantiteFrais[frais.nature!] ?? 'Nombre'"
              class="col-14 col-sm-36"
              :placeholder="LibelleTypeQuantiteFrais[frais.nature!] ?? 'Nombre de ...'"
              :decimal="0"
              separateur
              deletable
              :readonly
              :alertLabel="typeData.metaFrais?.at(index)?.quantite?.$messageErreurDirty!"
              :required="typeData.metaFrais?.at(index)?.quantite?.$status === PropertyStatus.Required"
              :disabled="typeData.metaFrais?.at(index)?.quantite?.$status === PropertyStatus.NotPresent"
            />
            <WrapperInputNumber
              v-if="typeData.metaFrais?.at(index)?.montant?.$status !== PropertyStatus.NotPresent"
              :model-value="frais.montant"
              @update:model-value="
                (montant) =>
                  modifieFrais({
                    mode: frais.mode!,
                    nature: frais.nature!,
                    valeur: montant!,
                    field: 'montant',
                  })
              "
              :hint="typeData?.fraisHelp![frais.nature!]"
              :label="getMontantFraisLib(frais)"
              class="col-14 col-sm-36"
              :placeholder="LABEL_MONTANT_DEMANDE_HT + ' en €'"
              :decimal="2"
              separateur
              deletable
              :readonly
              :alertLabel="typeData.metaFrais?.at(index)?.montant?.$messageErreurDirty!"
              :required="typeData.metaFrais?.at(index)?.montant?.$status === PropertyStatus.Required"
            />
            <WrapperInputNumber
              v-else
              :hint="typeData?.fraisHelp![frais.nature!]"
              :label="getMontantFraisLib(frais)"
              class="col-14 col-sm-36"
              :placeholder="LABEL_MONTANT_DEMANDE_HT + ' en €'"
              disabled
            />
          </div>
        </div>
        <div class="form__bloc">
          <div class="col-18 col-md-36 form__bloc">
            <BasicText
              weight="bold"
              class="col-36"
            >
              Montant Total HT
            </BasicText>
            <BasicInputNumber
              :model-value="montantsTotauxParType[type] ?? 0"
              class="col-14 col-sm-36"
              :decimal="2"
              separateur
              disabled
              label="Montant Total HT"
            />
          </div>
        </div>
      </template>
    </FormContainer>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import type { NatureFrais } from '@/features/domaine/types/opco'
  import { FormContainer, LABEL_MONTANT_DEMANDE_HT } from '@/features/interface/demande/shared'
  import type { FraisProps } from './Frais.types'
  import { LibelleTypeMontantFrais, LibelleTypeQuantiteFrais } from './Frais.types'
  import { useFraisFormation } from './useFraisFormation'

  const props = defineProps<FraisProps>()

  const { getNatureFraisLib, lignesFrais, montantsTotauxParType, getMontantFraisLib, afficheQuantité } =
    useFraisFormation(props)

  const headerCols = computed(() =>
    afficheQuantité.value
      ? [
          { span: 10, text: 'Type frais' },
          { span: 1 },
          { span: 10, text: 'Nature' },
          { span: 1 },
          { span: 6, text: 'Montant HT', extraClass: 'elem--right' },
          { span: 1 },
          { span: 6, text: 'Quantité', extraClass: 'elem--right' },
        ]
      : [
          { span: 12, text: 'Type frais' },
          { span: 1 },
          { span: 13, text: 'Nature' },
          { span: 1 },
          { span: 7, text: 'Montant HT', extraClass: 'elem--right' },
        ],
  )
</script>

<style scoped lang="less">
  .total--row {
    background-color: @neutral-100;
    height: 42px;
  }

  .elem--right {
    margin-left: auto;
    margin-right: 10px;
  }

  .label-required {
    color: @danger-600;
    margin-left: 4px;
  }

  .label-hint {
    margin-left: 4px;
  }
</style>
